<template>
    <SimpleModal v-if="showModal" wide @close="$emit('close')">
        <template v-slot:header>
            <h1>Select areas where you are looking</h1>
        </template>
        <template v-slot:body>
            <div class="form-group position-relative">
                <v-select
                    placeholder="Address or title"
                    :options="searchOptions"
                    :clearSearchOnSelect="false"
                    :clearable="false"
                    :filterable="false"
                    v-model="searchSelected"
                    @search="onSearch"
                    @option:selected="selectSmallArea($event.value)"></v-select>
                <SearchIcon class="search-icon" />
            </div>
            <div class="select-areas">
                <div class="select-areas__left">
                    <div class="select-areas__col">
                        <ul>
                            <li
                                v-for="(mainAreaList, mainAreaName) in areasList"
                                :class="{ active: selectedMainArea === mainAreaName }"
                                :key="`main-area-${mainAreaName}`"
                                @click="selectMainArea(mainAreaName)">
                                {{ mainAreaName }}
                            </li>
                        </ul>
                    </div>

                    <div class="select-areas__col">
                        <ul v-if="selectedMainArea">
                            <li
                                v-for="(middleAreaList, middleAreaName) in areasList[selectedMainArea]"
                                :class="{ active: selectedMiddleArea === middleAreaName }"
                                :key="`middle-area-${middleAreaName}`"
                                @click="selectMiddleArea(middleAreaName)">
                                {{ middleAreaName }}
                            </li>
                        </ul>
                    </div>

                    <div class="select-areas__col">
                        <ul v-if="selectedMiddleArea">
                            <li
                                v-for="(smallAreaDetails, smallAreaName) in areasList[selectedMainArea][selectedMiddleArea]"
                                :class="{ active: selectedSmallArea === smallAreaDetails.name_1 }"
                                :key="`small-area-${smallAreaName}`"
                                @click="selectSmallArea(smallAreaDetails)">
                                <input type="checkbox" :checked="selectedAreas.find((item) => item.place_id === smallAreaDetails.place_id)" />
                                {{ smallAreaDetails.name_1 }}
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="select-areas__right">
                    <div class="select-areas__col">
                        <div class="select-areas__col-header">
                            <h4 class="mb-0">Selected areas</h4>
                        </div>
                        <ul>
                            <li v-for="(areaDetails, key) in selectedAreas" :key="`selected-area-${key}`">
                                {{ areaDetails.name }}
                                <span title="Remove this from list" @click="removeArea(key)"> &times; </span>
                            </li>
                        </ul>
                        <div class="select-areas__col-footer">
                            <button type="button" class="btn btn--primary" @click.prevent="$emit('close')">Done</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </SimpleModal>
</template>

<script>
import _ from 'lodash';
import vSelect from 'vue-select';
import SimpleModal from '@components/partials/modal/SimpleModal.vue';
import SearchIcon from '@components/partials/icons/SearchIcon.vue';

export default {
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        value: {
            type: Array,
            required: true,
        },
    },
    components: {
        vSelect,
        SimpleModal,
        SearchIcon,
    },
    data() {
        return {
            areasList: {},
            selectedMainArea: '',
            selectedMiddleArea: '',
            selectedSmallArea: '',
            selectedAreas: [],
            searchOptions: [],
            searchSelected: null,
        };
    },
    created() {
        this.axios.post('/api/area/list', {}).then(({ data }) => {
            this.areasList = data;
            this.value.forEach((item) => {
                this.selectSmallArea(item);
            });
        });
    },
    updated() {
        if (this.showModal) {
            this.searchOptions = [];
            this.searchSelected = null;
        }
    },
    watch: {
        areasList(value) {
            const keys = Object.keys(value);
            if (keys.length && !this.selectedMainArea) {
                [this.selectedMainArea] = keys;
                [this.selectedMiddleArea] = Object.keys(value[this.selectedMainArea]);
            }
        },
    },
    methods: {
        selectMainArea(mainAreaName) {
            this.selectedMainArea = mainAreaName;
        },
        selectMiddleArea(middleAreaName) {
            this.selectedMiddleArea = middleAreaName;
        },
        selectSmallArea(areaDetails) {
            const selectedArea = this.selectedAreas.find((area) => area.place_id === areaDetails.place_id);

            if (!selectedArea) {
                this.selectedAreas.push({
                    place_id: areaDetails.place_id,
                    name: areaDetails.name_1,
                    formatted_name: areaDetails.formatted_name,
                });
            } else {
                this.selectedAreas.splice(this.selectedAreas.indexOf(selectedArea), 1);
            }
            this.$emit('input', this.selectedAreas);
        },
        removeArea(key) {
            this.selectedAreas.splice(key, 1);
            this.$emit('input', this.selectedAreas);
        },
        onSearch: _.debounce(function (searchValue) {
            this.searchOptions = [];
            this.searchSelected = null;

            if (searchValue.length < 3) {
                return;
            }

            Object.keys(this.areasList).forEach((mainArea) => {
                Object.keys(this.areasList[mainArea]).forEach((middleArea) => {
                    this.areasList[mainArea][middleArea].forEach((area) => {
                        const areaName = area.name_1.toLowerCase();
                        const search = searchValue.toLowerCase();
                        const searchWords = search.split(' ');
                        const machedAllWords = searchWords.every((word) => areaName.includes(word));
                        if (machedAllWords) {
                            this.searchOptions.push({
                                label: area.formatted_name,
                                value: area,
                            });
                        }
                    });
                });
            });

            this.searchOptions.sort();
        }, 500),
    },
};
</script>

<style lang="scss">
.form-group .v-select input.vs__search::placeholder {
    color: var(--gray-500);
}

.search-icon {
    position: absolute;
    right: var(--spacing-small);
    bottom: 10px;
}
</style>
